import { atom, selectorFamily } from 'recoil';
import type { SessionHydration_Asset_Image } from '~/graphql/types';

export const assetsState = atom<{
  images: Array<SessionHydration_Asset_Image>;
}>({
  key: 'assetsState',
  default: {
    images: [],
  },
});

export const assetExistsState = selectorFamily<boolean, string>({
  key: 'assetExistsState',
  get:
    (assetId: string) =>
    ({ get }) => {
      const asset = get(assetsState).images.find(({ id }) => id === assetId);
      return asset != null;
    },
});
